import AdvantageCardList from "@/components/advantageCard";
import { LBGhoverEffect } from "styles/hoverPresets";
import { ADVANTAGES_CONSTANTS } from "./constants";

const AdvantageComp = () => {
  return (
    <AdvantageCardList
      items={ADVANTAGES_CONSTANTS}
      hoverEffect
      hover={LBGhoverEffect}
      columns={{ base: 1, sm: 2, md: 4 }}
    />
  );
};

export default AdvantageComp;
